import API from '@/api'

export default {
  namespaced: true,
  state: {

    data: [],

    filters: {
      type: 'soil-grown',
      search: '',
    }
  },
  mutations: {
    setData(state, data) {
      state.data = data;
    },
    setType(state, type) {
      state.filters.type = type;
    },
    setSearch(state, query) {
      state.filters.search = query;
    },
  },
  actions: {

    updateData({ commit, state }) {
      return API.crop.getUserCrops(state.filters).then(res => {
        commit('setData', res.data.data);
      });
    },
    // getCrops({ commit, state }) {
    //   return API.crop.getCropsByFilter(state.filters).then(res => {
    //     commit('setData', res.data.data);
    //   });
    // }

  },
  getters: {
    data(state) {
      return state.data
    },
    filters(state) {
      return state.filters
    },

  }
};
